import { defineComponent as i, h as t } from "vue";
import { getModeFromValue as a, convertColor as c } from "./ghl-ui.es902.js";
const u = i({
  name: "ColorPreview",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: null,
      validator: (e) => {
        const o = a(e);
        return !!(!e || o && o !== "hsv");
      }
    },
    onUpdateColor: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    function o(n) {
      var r;
      const l = n.target.value;
      (r = e.onUpdateColor) === null || r === void 0 || r.call(e, c(l.toUpperCase(), e.mode, "hex")), n.stopPropagation();
    }
    return {
      handleChange: o
    };
  },
  render() {
    const {
      clsPrefix: e
    } = this;
    return t("div", {
      class: `${e}-color-picker-preview__preview`
    }, t("span", {
      class: `${e}-color-picker-preview__fill`,
      style: {
        background: this.color || "#000000"
      }
    }), t("input", {
      class: `${e}-color-picker-preview__input`,
      type: "color",
      value: this.color,
      onChange: this.handleChange
    }));
  }
});
export {
  u as default
};
